class AutoupdateCtrl  
  @$inject: ["$rootScope", "$scope", "$state", "toasty", "editor", "warning", "Autoupdate"]  
  constructor: ($rootScope, $scope, $state, toasty, editor, warning, Autoupdate)->    
    $scope.create = ($resource)->
      autoupdate = new Autoupdate
        type: "IMMEDIATELY"
        os: "ANDROID"
      options = 
        source: autoupdate
        schema:
          name:
            type: "String"
            display: "Name"
            required: true
          type:
            type: "String"
            display: "Type"
            required: true
            enum: [{display:'Immediately', value: 'IMMEDIATELY'}, {display: 'Next Online', value: 'BUNDLE'}]
          os:
            type: "String"
            display: "OS"
            required: true
            enum: [{value: 'ANDROID'}, {value: 'LINUX'}]
          reboot:
            type: "Boolean"
            display: "Reboot after install"

      editor.edit(options).then (result)->
        result.$save()
      .then (result)->
        $resource.refresh()        
        toasty.success
          title: 'Create Auto Update Success'
          msg: "Create Auto Update #{result.name} success"
    $scope.edit = (autoupdate)->
      options = 
        source: autoupdate
        schema:
          name:
            type: "String"
            display: "Name"
            required: true
          type:
            type: "String"
            display: "Type"
            required: true
            enum: [{display:'Immediately', value: 'IMMEDIATELY'}, {display: 'Next Online', value: 'BUNDLE'}]
          os:
            type: "String"
            display: "OS"
            required: true
            enum: [{value: 'ANDROID'}, {value: 'LINUX'}]

      editor.edit(options).then (result)->
        console.log result

    $scope.remove = (autoupdate, $resource)->    
      options = 
        title: "Remove autoupdate"
        msg: "Confirm to remove #{autoupdate.name}?"
      warning.warn(options).then ()->
        autoupdate.$remove()
      .then ()=>
        $resource.refresh()
        toasty.success
          title: 'Remove Report Success'
          msg: "Remove #{autoupdate.name} success"  

    remove =
      html: "<a><i class='fa fa-trash'></i>Remove</a>"
      enabled: -> true
      click: (scope) =>
        {autoupdate, $resource} = scope        
        options = 
          title: "Remove autoupdate #{autoupdate.name}"
          msg: "Would you confirm to remove this?"        
        warning.warn(options).then ()->      
          autoupdate.$remove()
        .then ()=>
          $resource.refresh()
          toasty.success
            title: 'Remove Success'
            msg: "Remove #{autoupdate.name} success"
    $scope.menu = [remove]


module.exports = AutoupdateCtrl




// WEBPACK FOOTER //
// ./src/component/autoupdate/controller.coffee